let leadsEmailAddress = 'leads@evergreenonlineleads.com'
let billingFrequencies = {
  monthly: 'monthly',
  semimonthly: 'semimonthly',
}

module.exports = {
  leadsEmailAddress,
  billingFrequencies,
}
